import { SECRETARY_LIST_TYPE_ALL } from '@/constants/secretaryListType'
import secretariesApi from '@/services/api/secretaries'
import useServerList from '@/composables/useServerList'

// Admin /secretary-users list page (CAM-1477 follow-up). Search matches first/last name +
// committee name (server-side), same as the legacy DataTable search + Drafts' committee
// "find secretaries" deep link (?search=<committee name>).
export default function useSecretariesList() {
  return useServerList(secretariesApi.getList, {
    defaultSort: 'last_name',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    extraFilters: {
      committee_id: [],
      type: SECRETARY_LIST_TYPE_ALL
    }
  })
}



// WEBPACK FOOTER //
// ./src/composables/secretaries/useSecretariesList.js